export type Translations = {
	nav: {
		about: string;
		aboutSubmenu: {
			profile: string;
			upravenOdbor: string;
			nadzorenOdbor: string;
			organizaciskaStruktura: string;
			hotelskiMenadzment: string;
			povazniAkti: string;
			organizacija: string;
		};
		ourHotels: string;
		news: string;
		investors: string;
		contact: string;
		career: string;
		mobileOpen: string;
		mobileClose: string;
	};
	hero: {
		label: string;
		headline1: string;
		headline2: string;
		description1: string;
		description2: string;
	};
	aboutSection: {
		label: string;
		heading1: string;
		heading2: string;
		p1: string;
		p2: string;
		cta: string;
	};
	portfolio: {
		label: string;
		heading1: string;
		heading2: string;
		description: string;
		pullQuote: string;
		p1: string;
		p2: string;
		p3: string;
		locationBadge: string;
		reserve: string;
	};
	partners: {
		label: string;
		heading1: string;
		heading2: string;
		intro: string;
		corporateServicesLabel: string;
		whyUs: string;
		benefits: string[];
		ctaTitle: string;
		ctaDesc: string;
		ctaButton: string;
	};
	values: {
		label: string;
		heading1: string;
		heading2: string;
		intro: string;
	};
	careerSection: {
		label: string;
		heading1: string;
		heading2: string;
		description: string;
		openPositions: string;
		positionCol: string;
		typeCol: string;
		apply: string;
		partTime: string;
		fullTime: string;
		seeAll: string;
		modalPositionLabel: string;
		modalPartTime: string;
		modalFullTime: string;
		modalTasksHeading: string;
		modalQualificationsHeading: string;
		modalOffersHeading: string;
		modalApplyLabel: string;
		modalFill: string;
		namePlaceholder: string;
		phonePlaceholder: string;
		uploadResume: string;
		uploadDesc: string;
		submit: string;
		submitting: string;
		submitError: string;
		successTitle: string;
		successDesc: string;
		privacy: string;
		noPositions: string;
	};
	news: {
		label: string;
		heading: string;
		desc: string;
		readMore: string;
		seeAll: string;
	};
	opportunities: {
		investorsLabel: string;
		keyInfo: string;
		heading1: string;
		heading2: string;
		intro: string;
		cta: string;
		items: Array<{ title: string; subtitle: string }>;
	};
	contactSection: {
		label: string;
		heading: string;
		intro: string;
		namePlaceholder: string;
		emailPlaceholder: string;
		messagePlaceholder: string;
		submit: string;
		moreOptions: string;
		officeHeading: string;
		addressLabel: string;
		addressValue: string;
		phoneLabel: string;
		emailLabel: string;
	};
	footer: {
		tagline: string;
		hospitality: string;
		explore: string;
		aboutUs: string;
		ourHotels: string;
		partners: string;
		contact: string;
		legal: string;
		privacy: string;
		terms: string;
		office: string;
		address: string;
		companyName: string;
		allRights: string;
	};
	aboutPage: {
		hero: {
			label: string;
			heading: string;
			intro: string;
			portfolioLabel: string;
			portfolioValue: string;
			locationLabel: string;
			locationValue: string;
			focusLabel: string;
			focusValue: string;
		};
		story: {
			heading1: string;
			heading2: string;
			p1: string;
			p2: string;
			forWhoLabel: string;
		};
		audiences: string[];
		goals: Array<{ title: string; description: string }>;
		portfolioSection: {
			label: string;
			heading: string;
			intro: string;
			viewPortfolio: string;
			contact: string;
			skopje: string;
			brandArchTitle: string;
			brandArchDesc: string;
			brandArchNote: string;
		};
		valuesSection: {
			label: string;
			heading: string;
			intro: string;
			contactNote: string;
			contactCta: string;
		};
		brandValues: Array<{ title: string; description: string }>;
	};
	careerPage: {
		hero: {
			label: string;
			heading1: string;
			heading2: string;
			intro: string;
			openPositionsLabel: string;
			hotelsLabel: string;
			locationLabel: string;
			positionsLabel: string;
		};
		positions: {
			heading: string;
			noPositions: string;
			apply: string;
			partTime: string;
			fullTime: string;
		};
		filters: {
			all: string;
			reception: string;
			kitchen: string;
			restaurant: string;
			housekeeping: string;
			management: string;
			maintenance: string;
			events: string;
		};
		inquiry: {
			heading1: string;
			heading2: string;
			intro: string;
			bullets: string[];
			formHeading: string;
			formDesc: string;
			namePlaceholder: string;
			phonePlaceholder: string;
			emailPlaceholder: string;
			uploadCv: string;
			uploadDesc: string;
			submit: string;
			privacy: string;
		};
		modal: {
			positionLabel: string;
			partTime: string;
			fullTime: string;
			tasksHeading: string;
			qualificationsHeading: string;
			offersHeading: string;
			applyLabel: string;
			fill: string;
			namePlaceholder: string;
			phonePlaceholder: string;
			uploadResume: string;
			uploadDesc: string;
			submit: string;
			privacy: string;
		};
	};
	contactPage: {
		hero: {
			label: string;
			heading: string;
			intro: string;
		};
		form: {
			label: string;
			heading: string;
			nameLabel: string;
			namePlaceholder: string;
			emailLabel: string;
			phoneLabel: string;
			hotelLabel: string;
			hotelDefault: string;
			messageLabel: string;
			messagePlaceholder: string;
			submit: string;
		};
		info: {
			label: string;
			heading: string;
			mainOfficeLabel: string;
			hotelsLabel: string;
		};
		map: {
			directions: string;
		};
	};
	upravenOdbor: {
		backLink: string;
		orgLabel: string;
		heading: string;
		intro: string;
		membersHeading: string;
		responsibilities: string;
		responsibilitiesText: string;
		moreLink: string;
		contactNote: string;
		contactBtn: string;
		presidentTitle: string;
		memberTitle: string;
		presidentName: string;
		memberName: string;
		presidentDesc: string;
		memberDesc: string;
	};
	nadzorenOdbor: {
		backLink: string;
		orgLabel: string;
		heading: string;
		intro: string;
		membersHeading: string;
		responsibilities: string;
		responsibilitiesText: string;
		moreLink: string;
		contactNote: string;
		contactBtn: string;
		presidentTitle: string;
		memberTitle: string;
		presidentName: string;
		memberName: string;
		presidentDesc: string;
		memberDesc: string;
	};
	hotelskiMenadzment: {
		backLink: string;
		orgLabel: string;
		heading: string;
		intro: string;
		managersHeading: string;
		position: string;
		managers: Array<{ hotel: string; description: string }>;
	};
	organizaciskaStruktura: {
		backLink: string;
		orgLabel: string;
		heading: string;
		underConstruction: string;
		comingSoon: string;
	};
	povazniAkti: {
		backLink: string;
		transparencyLabel: string;
		heading: string;
		intro: string;
		documentsHeading: string;
		documentsDesc: string;
		download: string;
		noteLabel: string;
		noteText: string;
		notFoundNote: string;
		contactBtn: string;
		categories: Array<{
			label: string;
			docs: Array<{
				name: string;
				description: string;
				type: string;
				href?: string;
			}>;
		}>;
	};
	investitoriPage: {
		label: string;
		heading: string;
		intro: string;
		emailLabel: string;
		passwordLabel: string;
		submit: string;
		announcementsHeading: string;
		announcementsDesc: string;
		publishedLabel: string;
		attachmentsLabel: string;
		open: string;
		announcements: Array<{
			title: string;
			date: string;
			attachments: Array<{
				name: string;
				href: string;
				type: string;
			}>;
		}>;
	};
	newsPage: {
		label: string;
		heading: string;
		intro: string;
		readMore: string;
		newsImage: string;
	};
	articlePage: {
		backToNews: string;
		mainImage: string;
		body1: string;
		keyPointsHeading: string;
		body2: string;
		bullets: string[];
		whatNextHeading: string;
		body3: string;
		body4: string;
		backToAllNews: string;
	};
	privacyPolicy: {
		heading: string;
		lastUpdated: string;
		intro: string;
		sections: Array<{
			heading: string;
			paragraphs: string[];
			items?: string[];
			postParagraphs?: string[];
		}>;
		documentsHeading: string;
		documents: Array<{ label: string; href: string }>;
	};
	termsOfService: {
		heading: string;
		lastUpdated: string;
		sections: Array<{
			heading: string;
			paragraphs: string[];
			items?: string[];
		}>;
	};
};

const mk: Translations = {
	nav: {
		about: "За нас",
		aboutSubmenu: {
			profile: "Профил",
			upravenOdbor: "Управен одбор",
			nadzorenOdbor: "Надзорен одбор",
			organizaciskaStruktura: "Организациска структура",
			hotelskiMenadzment: "Хотелски менаџмент",
			povazniAkti: "Поважни акти",
			organizacija: "Организација",
		},
		ourHotels: "Наши хотели",
		news: "Вести",
		investors: "Инвеститори",
		contact: "Контакт",
		career: "Кариера",
		mobileOpen: "Отвори мени",
		mobileClose: "Затвори мени",
	},
	hero: {
		label: "Хотелска групација · Скопје",
		headline1: "Водечка хотелска",
		headline2: "групација во Скопје.",
		description1:
			"Меѓународни стандарди, локално гостопримство и повеќе од 60 години искуство во хотелската индустрија.",
		description2:
			"Колекција од внимателно позиционирани хотели за бизнис патувања, настани, конференции и одмор. На најдобрите локации во Скопје.",
	},
	aboutSection: {
		label: "За нас",
		heading1: "За",
		heading2: "Македонијатурист",
		p1: "Македонијатурист АД е една од најреномираните хотелски компании во Македонија, управувајќи портфолио на градски и ресорт хотели во Скопје.",
		p2: "Нашата група ги обединува глобалните хотелски стандарди со длабоко разбирање на локалниот пазар, обезбедувајќи конзистентен квалитет за индивидуални гости, корпоративни клиенти и меѓународни организации.",
		cta: "Повеќе за нас",
	},
	portfolio: {
		label: "Наши Хотели",
		heading1: "Различни хотели.",
		heading2: "Единствен стандард.",
		description:
			"Од интернационални брендови до хотели со традиција и природна околина. Секој објект нуди уникатен карактер поддржан со сигурен квалитет на услуга.",
		pullQuote: "Едно од најзначајните хотелски портфолија во Скопје.",
		p1: "Македонијатурист АД управува со едно од најзначајните хотелски портфолија во Скопје, нудејќи врвно сместување, бизнис услуги и искуства за гости од целиот свет. Со децениско искуство во хотелиерството, нашите хотели претставуваат идеален избор за деловни патувања, туристички посети, конференции, свадби и приватни настани.",
		p2: "Нашето портфолио опфаќа реномирани хотели во Скопје со одлични локации, модерни капацитети и високи стандарди на услуга. Без разлика дали патувате за бизнис или за одмор, хотелите на Македонијатурист обезбедуваат удобност, професионална услуга и врвно гостопримство.",
		p3: "Со современи конференциски сали, ресторани, простори за настани и комплетна поддршка за организирање на деловни и приватни настани, Македонијатурист е еден од водечките хотелски оператори во Македонија.",
		locationBadge: "Скопје",
		reserve: "Резервирај",
	},
	partners: {
		label: "Корпоративни партнерства",
		heading1: "Партнер за бизнис",
		heading2: "патувања и настани",
		intro:
			"Македонијатурист е доверлив партнер за корпоративни престои, конференции, MICE настани и групни резервации во Скопје.",
		corporateServicesLabel: "Корпоративни услуги",
		whyUs: "Зошто Македонијатурист",
		benefits: [
			"Централни локации",
			"Конференциски капацитети",
			"Координација преку една контакт точка",
			"Флексибилни корпоративни услови",
		],
		ctaTitle: "Брз одговор, јасни услови",
		ctaDesc: "Побарајте понуда со наведување на типот гости, период и буџет.",
		ctaButton: "Контакт",
	},
	values: {
		label: "Нашите вредности",
		heading1: "Начинот",
		heading2: "на кој работиме",
		intro:
			"Гостопримството за нас значи доверба, конзистентност и внимание кон секој детал. Нашата цел е секој престој да биде професионален, удобен и предвидливо квалитетен.",
	},
	careerSection: {
		label: "Кариера",
		heading1: "Биди дел од",
		heading2: "хотелиерската револуција.",
		description:
			"Нашиот тим од професионалци постојано расте, а токму ти можеш да придонесеш за вистинска промена во хотелиерството и поставување нови стандарди. Погледни ги отворените позиции и добредојде во тимот на Македонијатурист АД.",
		openPositions: "отворени позиции",
		positionCol: "Позиција",
		typeCol: "Тип",
		apply: "Аплицирај",
		partTime: "Скратено",
		fullTime: "Полно",
		seeAll: "Види ги сите огласи",
		modalPositionLabel: "Позиција",
		modalPartTime: "Скратено работно",
		modalFullTime: "Полно работно",
		modalTasksHeading: "Работни задачи",
		modalQualificationsHeading: "Потребни квалификации",
		modalOffersHeading: "Што нуди Македонијатурист",
		modalApplyLabel: "Аплицирај",
		modalFill: "Пополни ги полињата и прикачи резиме.",
		namePlaceholder: "Ime и презиме",
		phonePlaceholder: "Телефон",
		uploadResume: "Прикачи резиме",
		uploadDesc: "PDF, до 5MB",
		submit: "Испрати апликација",
		submitting: "Се испраќа...",
		submitError: "Се случи грешка. Обидете се повторно.",
		successTitle: "Пријавата е испратена!",
		successDesc: "Ќе стапиме во контакт наскоро.",
		privacy: "Вашите податоци се третираат доверливо согласно ЗЗЛП.",
		noPositions: "Во моментов нема отворени позиции.",
	},
	news: {
		label: "Вести",
		heading: "Од нашата групација",
		desc: "Најнови вести, настани и новини од Македонијатурист и нашите хотели.",
		readMore: "Прочитај повеќе",
		seeAll: "Сите вести",
	},
	opportunities: {
		investorsLabel: "Инвеститори",
		keyInfo: "Клучни информации",
		heading1: "Транспарентност",
		heading2: "и раст",
		intro:
			"Македонијатурист АД е јавно акционерско друштво котирано на Македонска берза. Корпоративно управување, редовно известување и одржлив развој се темелите на нашата работа.",
		cta: "Панел за инвеститори",
		items: [
			{
				title: "Котирано на Македонска берза",
				subtitle: "Симбол: MTUR",
			},
			{
				title: "Редовни финансиски извештаи",
				subtitle: "Квартални и годишни објави",
			},
			{
				title: "Годишни собранија на акционери",
				subtitle: "Отворено и транспарентно управување",
			},
		],
	},
	contactSection: {
		label: "Контакт",
		heading: "Брз контакт",
		intro:
			"Испратете ни брза порака и ние ќе ви одговориме во најкраток можен рок.",
		namePlaceholder: "Име и презиме",
		emailPlaceholder: "Email адреса",
		messagePlaceholder: "Вашата порака...",
		submit: "Испрати порака",
		moreOptions: "Повеќе опции и информации",
		officeHeading: "Главна канцеларија",
		addressLabel: "Адреса",
		addressValue: "ул. Филип Втори Македонски бр.5\n1000 Скопје",
		phoneLabel: "Телефон",
		emailLabel: "Email",
	},
	footer: {
		tagline: "Локално срце. Градски комфор.",
		hospitality: "Гостопримство од 1963.",
		explore: "Истражи",
		aboutUs: "За нас",
		ourHotels: "Нашите хотели",
		partners: "Партнери",
		contact: "Контакт",
		legal: "Правно",
		privacy: "Политика за приватност",
		terms: "Услови на користење",
		office: "Канцеларија",
		address:
			"Makedonijaturist AD\nул. Филип Втори Македонски бр.5\n1000 Скопје, Македонија",
		companyName: "Македонијатурист АД",
		allRights: "Сите права задржани.",
	},
	aboutPage: {
		hero: {
			label: "Локално срце. Градски комфор.",
			heading: "За Македонијатурист АД",
			intro:
				"Македонијатурист АД е корпоративниот бренд што ја претставува групацијата како целина. За партнери и гости, тоа значи стабилни стандарди, организирана координација и топол пристап во секој контакт.",
			portfolioLabel: "Портфолио",
			portfolioValue: "хотели",
			locationLabel: "Локација",
			locationValue: "Скопје",
			focusLabel: "Фокус",
			focusValue: "B2B и градски престој",
		},
		story: {
			heading1: "Автентично гостопримство,",
			heading2: "современа организација.",
			p1: "Македонија отсекогаш била земја на гости, домови што се отвораат и градови што ги пречекуваат патниците со насмевка. Од тие вредности произлегува Македонијатурист АД.",
			p2: "Го спојуваме сигурниот систем на современ хотелски менаџмент со топлината на домаќин. Нашата цел е едноставна: секој престој да биде лесен, топол и професионален, без непотребни компликации.",
			forWhoLabel: "За кого работиме",
		},
		audiences: [
			"Туристички агенции, туроператори и DMC партнери",
			"Корпорации, институции и организатори на настани",
			"Инвеститори, партнери и медиуми",
		],
		goals: [
			{
				title: "Цел",
				description:
					"Да ја направиме Македонија природен избор за гости кои бараат искрено гостопримство, удобност и локално искуство во градска средина, за бизнис гости, туристи, групи и настани.",
			},
			{
				title: "Визија",
				description:
					"Да бидеме препознатливи по конзистентен стандард, модерен пристап во управувањето и силен локален карактер во секој хотел.",
			},
			{
				title: "Мисија",
				description:
					"Управуваме со градски хотели, ресторани и конгресни содржини. Обезбедуваме стабилен квалитет преку SOP-и, тренинг и јасна организација.",
			},
		],
		portfolioSection: {
			label: "Портфолио",
			heading: "Хотели со свој карактер",
			intro:
				"Секој хотел има сопствен стил, целна група и редовни гости. Македонијатурист АД стои како дискретна потврда за квалитет и стабилност.",
			viewPortfolio: "Погледни портфолио",
			contact: "Контакт",
			skopje: "Скопје",
			brandArchTitle: "Endorsed brand architecture",
			brandArchDesc:
				"Хотелските брендови имаат слобода да бидат јасни и препознатливи, а групацијата обезбедува чадор на кредибилитет и стандард.",
			brandArchNote: "Proud part of Makedonijaturist AD",
		},
		valuesSection: {
			label: "Вредности",
			heading: "Вредности што се чувствуваат во секој престој",
			intro:
				"Сериозен тон, топол прием и прецизно внимание на детали. Во нашата работа нема театар, има дисциплина и грижа.",
			contactNote:
				"За понуди, партнерства и корпоративна координација, нашиот тим е на располагање.",
			contactCta: "Контактирајте нè",
		},
		brandValues: [
			{
				title: "Гостопримство со срце",
				description:
					"Гостинот не е само број на соба, го третираме како гостин во наш дом.",
			},
			{
				title: "Конзистентен стандард",
				description:
					"Независно од хотел и смена, основното искуство треба да биде стабилно и предвидливо.",
			},
			{
				title: "Локален дух",
				description:
					"Во храната, атмосферата, препораките и пристапот секогаш постои добро сетирана локална нота.",
			},
			{
				title: "Професионалност и дисциплина",
				description:
					"Ги почитуваме SOP-ите, процедурите и договорените стандарди, со јасна организација и одговорности.",
			},
			{
				title: "Иновативност и ефикасност",
				description:
					"Ги користиме алатките и технологијата за да ја олесниме работата и да го подобриме искуството на гостинот.",
			},
			{
				title: "Одговорност и интегритет",
				description:
					"Ги исполнуваме ветувањата, преземаме одговорност кога има проблем и градиме фер однос со партнери и гости.",
			},
		],
	},
	careerPage: {
		hero: {
			label: "Придружи се на тимот",
			heading1: "Кариера во",
			heading2: "Македонијатурист",
			intro:
				"Бараме луѓе кои веруваат во гостопримство со срце. Работете во средина каде стандардот, тимскиот дух и локалниот карактер се на прво место.",
			openPositionsLabel: "Отворени позиции",
			hotelsLabel: "Хотели и локали",
			locationLabel: "Локација",
			positionsLabel: "позиции",
		},
		positions: {
			heading: "Отворени позиции",
			noPositions: "Нема позиции во оваа категорија.",
			apply: "Аплицирај",
			partTime: "Скратено",
			fullTime: "Полно",
		},
		filters: {
			all: "Сите",
			reception: "Рецепција",
			kitchen: "Кујна",
			restaurant: "Ресторан & Бар",
			housekeeping: "Домаќинство",
			management: "Менаџмент",
			maintenance: "Техника",
			events: "Настани",
		},
		inquiry: {
			heading1: "Општа пријава",
			heading2: "за работа",
			intro:
				"Не гледате соодветна позиција? Испратете општа пријава и ние ќе ве контактираме кога ќе се отвори соодветна можност.",
			bullets: [
				"Стабилна работна средина во воспоставена групација",
				"Развој на кариера низ сите хотели во портфолиото",
				"Тренинзи и програми за унапредување",
				"Соработка со меѓународни хотелски брендови",
			],
			formHeading: "Испрати пријава",
			formDesc: "Пополнете ги полињата и прикачете резиме.",
			namePlaceholder: "Ime и презиме",
			phonePlaceholder: "Телефон",
			emailPlaceholder: "Email адреса",
			uploadCv: "Прикачете CV",
			uploadDesc: "PDF, до 5MB",
			submit: "Испрати пријава",
			privacy: "Вашите податоци се третираат доверливо согласно ЗЗЛП.",
		},
		modal: {
			positionLabel: "Позиција",
			partTime: "Скратено работно",
			fullTime: "Полно работно",
			tasksHeading: "Работни задачи",
			qualificationsHeading: "Потребни квалификации",
			offersHeading: "Што нуди Македонијатурист",
			applyLabel: "Аплицирај",
			fill: "Пополни ги полињата и прикачи резиме.",
			namePlaceholder: "Ime и презиме",
			phonePlaceholder: "Телефон",
			uploadResume: "Прикачи резиме",
			uploadDesc: "PDF, до 5MB",
			submit: "Испрати апликација",
			privacy: "Вашите податоци се третираат доверливо согласно ЗЗЛП.",
		},
	},
	contactPage: {
		hero: {
			label: "Контакт",
			heading: "Стапете во контакт со нас",
			intro:
				"За престој, групи, настани или корпоративна соработка, испратете ни порака. Ќе ви одговориме јасно и навреме.",
		},
		form: {
			label: "Порака",
			heading: "Испратете порака",
			nameLabel: "Име и презиме",
			namePlaceholder: "Вашето ime",
			emailLabel: "Email адреса",
			phoneLabel: "Телефон (опционално)",
			hotelLabel: "Избери хотел (опционално)",
			hotelDefault: "Општо прашање",
			messageLabel: "Порака",
			messagePlaceholder: "Вашата порака...",
			submit: "Испрати порака",
		},
		info: {
			label: "Информации",
			heading: "Контакт информации",
			mainOfficeLabel: "Главна канцеларија",
			hotelsLabel: "Хотели, директен контакт",
		},
		map: {
			directions: "Насоки на мапа",
		},
	},
	upravenOdbor: {
		backLink: "За нас",
		orgLabel: "Организација",
		heading: "Управен одбор",
		intro:
			"Управниот одбор е колективен орган на управување на Македонијатурист АД Скопје, кој ја води деловната политика и работењето на Друштвото. Управниот одбор се состои од 3 члена. На еден од членовите му е доверена функцијата Претседател на Управниот одбор. Претседателот на Управниот одбор непосредно го води и застапува Друштвото.",
		membersHeading: "Членови на Управен одбор",
		responsibilities: "Надлежности на Управниот одбор",
		responsibilitiesText:
			"Надлежностите на Управниот одбор произлегуваат од Статутот на Македонијатурист АД Скопје.",
		moreLink: "Повеќе",
		contactNote:
			"За повеќе информации во врска со работата на Управниот одбор, контактирајте нè.",
		contactBtn: "Контакт",
		presidentTitle: "Претседател",
		memberTitle: "Член",
		presidentName: "Претседател на Управен одбор",
		memberName: "Член на Управен одбор",
		presidentDesc:
			"Раководи со работата на Управниот одбор и ги координира стратешките одлуки на друштвото.",
		memberDesc:
			"Учествува во донесувањето на стратешки одлуки и надгледување на работата на друштвото.",
	},
	nadzorenOdbor: {
		backLink: "За нас",
		orgLabel: "Организација",
		heading: "Надзорен одбор",
		intro:
			"Надзорниот одбор е колективен орган на надзор врз управувањето со Македонијатурист АД Скопје. Надзорниот одбор се состои од најмалку 3 члена, а еден од нив ја врши функцијата Претседател на Надзорниот одбор.",
		membersHeading: "Членови на Надзорен одбор",
		responsibilities: "Надлежности на Надзорниот одбор",
		responsibilitiesText:
			"Надлежностите на Надзорниот одбор произлегуваат од Статутот на Македонијатурист АД Скопје.",
		moreLink: "Повеќе",
		contactNote:
			"За повеќе информации во врска со работата на Надзорниот одбор, контактирајте нè.",
		contactBtn: "Контакт",
		presidentTitle: "Претседател",
		memberTitle: "Член",
		presidentName: "Претседател на Надзорен одбор",
		memberName: "Член на Надзорен одбор",
		presidentDesc:
			"Раководи со работата на Надзорниот одбор и ги координира активностите за надзор над работењето на друштвото.",
		memberDesc:
			"Учествува во надзорот над работењето и финансиското работење на друштвото.",
	},
	hotelskiMenadzment: {
		backLink: "За нас",
		orgLabel: "Организација",
		heading: "Хотелски менаџмент",
		intro:
			"Генералните менаџери на хотелите на Македонијатурист АД Скопје ги водат секојдневните операции и ги претставуваат своите хотели кон гостите и партнерите.",
		managersHeading: "Генерални менаџери",
		position: "Генерален менаџер",
		managers: [
			{
				hotel: "Holiday Inn Скопје",
				description:
					"Раководи со целокупното работење на Holiday Inn Скопје, обезбедувајќи усогласеност со IHG стандардите и врвно искуство за бизнис гости и MICE клиенти.",
			},
			{
				hotel: "Хотел Карпош",
				description:
					"Управува со секојдневните операции на Хотел Карпош, фокусирајќи се на квалитетен престој за бизнис гости и долгорочни посетители во срцето на Скопје.",
			},
			{
				hotel: "Хотел Турист",
				description:
					"Раководи со операциите на Хотел Турист, обезбедувајќи практичен и удобен престој за гости кои бараат централна локација во Скопје.",
			},
			{
				hotel: "Хотел Bellevue",
				description:
					"Управува со Хотел Bellevue, создавајќи мирна и природна атмосфера за семејства и групи кои бараат одмор надвор од градската гужва.",
			},
		],
	},
	organizaciskaStruktura: {
		backLink: "За нас",
		orgLabel: "Организација",
		heading: "Организациска структура",
		underConstruction: "Во изработка",
		comingSoon: "Оваа страница е во изработка. Наскоро ќе биде достапна.",
	},
	povazniAkti: {
		backLink: "За нас",
		transparencyLabel: "Транспарентност",
		heading: "Поважни акти",
		intro:
			"Клучните документи и акти кои ја регулираат работата на Македонијатурист АД, достапни за акционерите и јавноста.",
		documentsHeading: "Документи и акти",
		documentsDesc:
			"Сите важни правни, финансиски и оперативни документи на друштвото, достапни за преглед и преземање.",
		download: "Преземи",
		noteLabel: "Напомена",
		noteText:
			"Документите се ажурирани согласно законските обврски. За побарување на специфични документи или дополнителни информации, контактирајте нè преку формуларот за контакт или директно на нашата адреса.",
		notFoundNote: "Не го најдовте документот кој го барате? Контактирајте нè.",
		contactBtn: "Контакт",
		categories: [
			{
				label: "Статутарни документи",
				docs: [
					{
						name: "Статут на Македонијатурист АД",
						description:
							"Основниот акт на друштвото кој ги уредува правата и обврските на акционерите, органите на управување и работата на компанијата.",
						type: "PDF",
					},
					{
						name: "Кодекс за корпоративно управување",
						description:
							"Принципите и стандардите за корпоративно управување кои ги регулираат односите меѓу органите на управување и акционерите.",
						type: "PDF",
					},
				],
			},
			{
				label: "Финансиски извештаи",
				docs: [
					{
						name: "Ревидирани финансиски извештаи 2024",
						description:
							"Ревидирани финансиски извештаи на Македонијатурист АД за деловната 2024 година.",
						type: "PDF",
						href: "/Revidirani finansiski izvestai 2024.pdf",
					},
					{
						name: "Ревидирани финансиски извештаи 2023",
						description:
							"Ревидирани финансиски извештаи на Македонијатурист АД за деловната 2023 година.",
						type: "PDF",
						href: "/Revidirani finansiski izvestai 2023.pdf",
					},
				],
			},
		],
	},
	newsPage: {
		label: "Вести",
		heading: "Од нашата групација",
		intro:
			"Следете ги најновите вести, настани и новини од Македонијатурист и нашите хотели.",
		readMore: "Прочитај повеќе",
		newsImage: "Слика на вест",
	},
	articlePage: {
		backToNews: "Назад кон вести",
		mainImage: "Главна слика на веста",
		body1:
			"Македонијатурист продолжува со својата мисија да обезбеди врвна услуга и искуство за сите наши гости низ портфолиото на хотели. Оваа иницијатива е дел од нашата долгорочна стратегија за континуиран раст и развој.",
		keyPointsHeading: "Клучни точки",
		body2:
			"Низ годините, нашата посветеност кон квалитет и автентично македонско гостопримство останува непроменета. Оваа нова фаза ги носи следните подобрувања:",
		bullets: [
			"Подобрени услуги за нашите бизнис гости",
			"Модернизирани простории и опрема",
			"Зголемен фокус на локални производи и партнерства",
			"Дигитализација на услугите за полесна резервација",
		],
		whatNextHeading: "Што следува",
		body3:
			"Во наредните месеци, планираме да продолжиме со имплементација на нови стандарди низ сите наши објекти. Нашиот тим работи посветено за да обезбеди дека секој гост ќе почувствува топлина и професионалност што ги дефинираат нашите вредности.",
		body4:
			"За повеќе информации и понуди, ве поканувате да не контактирате или да ги посетите нашите хотели.",
		backToAllNews: "Назад кон сите вести",
	},
	investitoriPage: {
		label: "Инвеститори",
		heading: "Најава",
		intro: "Внесете ги вашите податоци за пристап.",
		emailLabel: "Email адреса",
		passwordLabel: "Лозинка",
		submit: "Најави се",
		announcementsHeading: "Соопштенија",
		announcementsDesc: "Јавно достапни документи и соопштенија за акционерите.",
		publishedLabel: "Објавено",
		attachmentsLabel: "Прилози",
		open: "Прегледај",
		announcements: [
			{
				title:
					"Одлука за назначување на лице за контакт со инвеститори бр. 02 - 3374 од 04.06.2026",
				date: "04.06.2026",
				attachments: [
					{
						name: "Одлука за назначување на лице за контакт со инвеститори бр. 02 - 3374 од 04.06.2026",
						href: "/investitori/%D0%9E%D0%B4%D0%BB%D1%83%D0%BA%D0%B0%20%D0%B7%D0%B0%20%D0%BD%D0%B0%D0%B7%D0%BD%D0%B0%D1%87%D1%83%D0%B2%D0%B0%D1%9A%D0%B5%20%D0%BD%D0%B0%20%D0%BB%D0%B8%D1%86%D0%B5%20%D0%B7%D0%B0%20%D0%BA%D0%BE%D0%BD%D1%82%D0%B0%D0%BA%D1%82%20%D1%81%D0%BE%20%D0%B8%D0%BD%D0%B2%D0%B5%D1%81%D1%82%D0%B8%D1%82%D0%BE%D1%80%D0%B8%20%D0%B1%D1%80.%2002%20-%203374%20%D0%BE%D0%B4%2004.06.2026.pdf",
						type: "PDF",
					},
				],
			},
			{
				title: "Предлог одлуки за собрание 22.05.2026",
				date: "29.04.2026",
				attachments: [
					{
						name: "Предлог одлуки за собрание",
						href: "/investitori/Predlog%20odluki%20za%20sobranie.pdf",
						type: "PDF",
					},
				],
			},
			{
				title: "Годишно собрание на акционери 22.05.2026",
				date: "21.04.2026",
				attachments: [
					{
						name: "Јавен повик Македонијатурист 22.05.2026",
						href: "/investitori/Javen%20povik%20Makedonijaturist%2022.05.2026.pdf",
						type: "PDF",
					},
					{
						name: "Материјали за акционерско собрание 22.05.2026",
						href: "/investitori/Materijali%20za%20akcionersko%20sobranie%2022.05.2026.pdf",
						type: "PDF",
					},
					{
						name: "Ревидирани финансиски извештаи Македонијатурист 2025",
						href: "/investitori/Revidirani%20finansiski%20izvestai%20Makedonijaturist%202025.pdf",
						type: "PDF",
					},
					{
						name: "Кодекс за корпоративно управување на АД котирани на МСЕ",
						href: "/investitori/Kodeks%20za%20korporativno%20upravuvanje%20na%20AD%20kotirani%20na%20MSE.pdf",
						type: "PDF",
					},
					{
						name: "Прашалници за ККУ",
						href: "/investitori/Prasalnici%20za%20KKU.xlsx",
						type: "XLSX",
					},
				],
			},
		],
	},
	privacyPolicy: {
		heading: "Политика за приватност",
		lastUpdated: "Последна промена: 16.08.2023 година",
		intro:
			"Оваа Политика за приватност објаснува кои се информациите кои за Вас ги собираме, како и за обработката на личните податоци која ја вршиме кога ја посетувате нашата веб-страница и/или кога користите некоја од нашите услуги. Ние во Македонијатурист АД Скопје ги собираме само оние лични податоци кои се неопходни за да ја оствариме нашата дејност согласно закон, а притоа да Ви ги обезбедиме најдобрите искуства и услуги.",
		sections: [
			{
				heading:
					"Кој е контролор на збирките на лични податоци и како можете да нѐ контактирате?",
				paragraphs: [
					"Контролор на личните податоци е Македонијатурист АД Скопје, со седиште на ул. Филип Втори Македонски бр.5, 1000 Скопје, Република Северна Македонија.",
					"Е-пошта: maktur@makedonijaturist.com.mk",
					"Веб страна: www.makedonijaturist.com.mk",
					"Телефон: +389 2 3292 731",
				],
			},
			{
				heading: "Лични податоци кои ги собираме",
				paragraphs: [
					"Кога ги користите услугите на хотелите на Македонијатурист АД, при склучувањето на договорите за хотелски услуги, обработуваме лични податоци (маке, презиме, датум на раѓање, вид и број на документ за идентификација, адреса на живеалиште, е-пошта и телефон) потребни за нашите обврски согласно Законот за угостителска дејност.",
					"При вашата регистрација и ноќевање во хотелите на Македонијатурист АД кои имаат договор за соработка со IHG (Holiday Inn) и/или Best Western (Hotel Belvi), Вашите лични податоци исто така ги обработуваат и тие компании согласно нивните политики за приватност.",
					"https://www.ihg.com/content/us/en/customer-care/privacy-policy",
					"https://www.bestwestern.com/en_US/about/privacy-policy.html",
				],
			},
			{
				heading: "Колачиња",
				paragraphs: [
					"Нашата веб-страница користи колачиња (cookies) за аналитички цели преку Google Analytics. Вашиот браузер може да ги блокира или избрише колачињата преку поставките на браузерот.",
				],
			},
			{
				heading: "Период на чување",
				paragraphs: [
					"Вашите лични податоци ги чуваме само колку што е потребно за остварување на целите за кои се собрани. По изминување на рокот, личните податоци безбедно се бришат.",
				],
			},
			{
				heading: "Безбедност на податоците",
				paragraphs: [
					"Ги преземаме сите потребни технички и организациски мерки за заштита на вашите лични податоци од неовластен пристап, промена, откривање или уништување.",
				],
			},
			{
				heading: "Вашите права",
				paragraphs: [
					"Согласно Законот за заштита на личните податоци, имате право да:",
				],
				items: [
					"Пристапите до вашите лични податоци",
					"Побарате исправка на нецелосни или неточни лични податоци",
					"Побарате бришење на личните податоци",
					"Приговарате на обработката на вашите лични податоци",
					"Побарате ограничување на обработката на лични податоци",
				],
				postParagraphs: [
					"За остварување на вашите права, можете да се обратите на нашиот Офицер за заштита на лични податоци на dpo@act.com.mk",
				],
			},
			{
				heading: "Измени и дополнувања",
				paragraphs: [
					"Македонијатурист АД го задржуваме правото периодично да ја ажурираме оваа Политика за приватност. Во случај на суштествени измени, ќе ве информираме преку нашата веб-страница.",
				],
			},
		],
		documentsHeading: "Обрасци за остварување на права",
		documents: [
			{
				label: "Известување за заштита на лични податоци",
				href: "/privacydocs/Известување-за-заштита-на-лични-податоци.pdf",
			},
			{
				label: "Барање за пристап до информации",
				href: "/privacydocs/Барање-за-пристап-до-информации-за-обработката-на-личните-податоци.pdf",
			},
			{
				label: "Барање за исправка на лични податоци",
				href: "/privacydocs/Барање-за-исправка-на-моите-лични-податоци.pdf",
			},
			{
				label: "Барање за бришење на лични податоци",
				href: "/privacydocs/Барање-за-бришење-на-лични-податоци.pdf",
			},
			{
				label: "Барање за ограничување на обработка",
				href: "/privacydocs/Барање-за-ограничување-на-обработка-на-моите-лични-податоци.pdf",
			},
		],
	},
	termsOfService: {
		heading: "Услови на користење",
		lastUpdated: "Последна измена: јануари 2025",
		sections: [
			{
				heading: "Прифаќање на условите",
				paragraphs: [
					"Со пристапувањето и користењето на оваа веб-страница, потврдувате дека сте ги прочитале, разбрале и се согласувате со овие Услови на користење. Доколку не се согласувате со кој и да е дел од овие услови, ве молиме не ја користете веб-страницата.",
				],
			},
			{
				heading: "Употреба на веб-страницата",
				paragraphs: [
					"Оваа веб-страница е наменета исклучиво за информативни цели. Забрането е: користење на страницата за незаконски или неовластени цели, обид за неовластен пристап до системите или мрежите на Друштвото, дистрибуција на штетни, лажни или навредливи содржини, и секакво дејство кое би можело да предизвика штета на Друштвото или на трети лица.",
				],
			},
			{
				heading: "Интелектуална сопственост",
				paragraphs: [
					"Сите содржини на оваа веб-страница, вклучувајќи текстови, слики, логоа, графики и дизајн, се интелектуална сопственост на Македонијатурист АД или на нивните соодветни носители на права и се заштитени со важечките закони за авторски права.",
					"Забрането е копирање, репродукција, дистрибуција или јавно прикажување на кои и да е содржини без претходна писмена согласност од Македонијатурист АД.",
				],
			},
			{
				heading: "Ограничување на одговорноста",
				paragraphs: [
					"Информациите на оваа веб-страница се обезбедени за општи информативни цели. Македонијатурист АД не гарантира за нивната точност, комплетност или актуелност.",
					"Друштвото не одговара за никаква директна или индиректна штета, загуба или трошоци произлезени од користењето или неможноста за користење на веб-страницата.",
				],
			},
			{
				heading: "Надворешни врски",
				paragraphs: [
					"Веб-страницата може да содржи линкови до веб-страници на трети страни. Македонијатурист АД не контролира и не одговара за содржините, политиките за приватност или практиките на тие веб-страници.",
				],
			},
			{
				heading: "Измени на условите",
				paragraphs: [
					"Македонијатурист АД го задржува правото да ги менува или ажурира овие Услови на користење во секое време, без претходна најава. Продолженото користење на веб-страницата по објавувањето на измените подразбира прифаќање на новите услови.",
				],
			},
			{
				heading: "Применливо право и надлежност",
				paragraphs: [
					"Овие Услови на користење се уредуваат и толкуваат во согласност со законите на Република Северна Македонија. Сите спорови кои произлегуваат од или се поврзани со овие Услови ќе бидат решавани пред надлежните судови во Скопје.",
				],
			},
		],
	},
};

const en: Translations = {
	nav: {
		about: "About",
		aboutSubmenu: {
			profile: "Profile",
			upravenOdbor: "Board of Directors",
			nadzorenOdbor: "Supervisory Board",
			organizaciskaStruktura: "Organizational Structure",
			hotelskiMenadzment: "Hotel Management",
			povazniAkti: "Key Documents",
			organizacija: "Organization",
		},
		ourHotels: "Our Hotels",
		news: "News",
		investors: "Investors",
		contact: "Contact",
		career: "Career",
		mobileOpen: "Open menu",
		mobileClose: "Close menu",
	},
	hero: {
		label: "Hotel Group · Skopje",
		headline1: "Leading hotel",
		headline2: "group in Skopje.",
		description1:
			"International standards, local hospitality and more than 60 years of experience in the hotel industry.",
		description2:
			"A collection of carefully positioned hotels for business travel, events, conferences and leisure. In the best locations in Skopje.",
	},
	aboutSection: {
		label: "About Us",
		heading1: "About",
		heading2: "Makedonijaturist",
		p1: "Makedonijaturist AD is one of the most reputable hotel companies in Macedonia, managing a portfolio of city and resort hotels in Skopje.",
		p2: "Our group combines global hotel standards with a deep understanding of the local market, delivering consistent quality for individual guests, corporate clients and international organisations.",
		cta: "Learn more",
	},
	portfolio: {
		label: "Our Hotels",
		heading1: "Different hotels.",
		heading2: "One standard.",
		description:
			"From international brands to hotels with tradition and natural surroundings. Each property offers a unique character backed by reliable service quality.",
		pullQuote: "One of the most significant hotel portfolios in Skopje.",
		p1: "Makedonijaturist AD manages one of the most significant hotel portfolios in Skopje, offering premium accommodation, business services and experiences for guests from around the world. With decades of experience in hospitality, our hotels are the ideal choice for business travel, tourist visits, conferences, weddings and private events.",
		p2: "Our portfolio encompasses renowned hotels in Skopje with excellent locations, modern facilities and high service standards. Whether you travel for business or leisure, Makedonijaturist hotels provide comfort, professional service and exceptional hospitality.",
		p3: "With modern conference halls, restaurants, event spaces and full support for organising business and private events, Makedonijaturist is one of the leading hotel operators in Macedonia.",
		locationBadge: "Skopje",
		reserve: "Book",
	},
	partners: {
		label: "Corporate Partnerships",
		heading1: "Partner for business",
		heading2: "travel and events",
		intro:
			"Makedonijaturist is a trusted partner for corporate stays, conferences, MICE events and group bookings in Skopje.",
		corporateServicesLabel: "Corporate Services",
		whyUs: "Why Makedonijaturist",
		benefits: [
			"Central locations",
			"Conference facilities",
			"Coordination through a single point of contact",
			"Flexible corporate terms",
		],
		ctaTitle: "Fast response, clear terms",
		ctaDesc: "Request a quote specifying the guest type, period and budget.",
		ctaButton: "Contact",
	},
	values: {
		label: "Our Values",
		heading1: "The way",
		heading2: "we work",
		intro:
			"For us, hospitality means trust, consistency and attention to every detail. Our goal is for every stay to be professional, comfortable and reliably excellent.",
	},
	careerSection: {
		label: "Career",
		heading1: "Be part of",
		heading2: "the hospitality revolution.",
		description:
			"Our team of professionals is constantly growing, and you can contribute to real change in hospitality and set new standards. Explore open positions and join the Makedonijaturist AD team.",
		openPositions: "open positions",
		positionCol: "Position",
		typeCol: "Type",
		apply: "Apply",
		partTime: "Part-time",
		fullTime: "Full-time",
		seeAll: "All career opportunities",
		noPositions: "We currently have no open positions.",
		modalPositionLabel: "Position",
		modalPartTime: "Part-time",
		modalFullTime: "Full-time",
		modalTasksHeading: "Job responsibilities",
		modalQualificationsHeading: "Required qualifications",
		modalOffersHeading: "What Makedonijaturist offers",
		modalApplyLabel: "Apply",
		modalFill: "Fill in the fields and attach your resume.",
		namePlaceholder: "Full name",
		phonePlaceholder: "Phone",
		uploadResume: "Upload resume",
		uploadDesc: "PDF, up to 5MB",
		submit: "Send application",
		submitting: "Sending...",
		submitError: "Something went wrong. Please try again.",
		successTitle: "Application submitted!",
		successDesc: "We will be in touch soon.",
		privacy: "Your data is treated confidentially in accordance with GDPR.",
	},
	news: {
		label: "News",
		heading: "From our group",
		desc: "Latest news, events and updates from Makedonijaturist and our hotels.",
		readMore: "Read more",
		seeAll: "All news",
	},
	opportunities: {
		investorsLabel: "Investors",
		keyInfo: "Key Information",
		heading1: "Transparency",
		heading2: "and growth",
		intro:
			"Makedonijaturist AD is a public joint-stock company listed on the Macedonia Stock Exchange. Corporate governance, regular reporting and sustainable development are the pillars of our work.",
		cta: "Investor Panel",
		items: [
			{
				title: "Listed on Macedonia Stock Exchange",
				subtitle: "Symbol: MTUR",
			},
			{
				title: "Regular financial reports",
				subtitle: "Quarterly and annual disclosures",
			},
			{
				title: "Annual shareholder meetings",
				subtitle: "Open and transparent governance",
			},
		],
	},
	contactSection: {
		label: "Contact",
		heading: "Quick contact",
		intro: "Send us a quick message and we will respond as soon as possible.",
		namePlaceholder: "Full name",
		emailPlaceholder: "Email address",
		messagePlaceholder: "Your message...",
		submit: "Send message",
		moreOptions: "More options and information",
		officeHeading: "Main Office",
		addressLabel: "Address",
		addressValue: "ul. Filip Vtori Makedonski 5\n1000 Skopje",
		phoneLabel: "Phone",
		emailLabel: "Email",
	},
	footer: {
		tagline: "Local heart. Urban comfort.",
		hospitality: "Hospitality since 1963.",
		explore: "Explore",
		aboutUs: "About Us",
		ourHotels: "Our Hotels",
		partners: "Partners",
		contact: "Contact",
		legal: "Legal",
		privacy: "Privacy Policy",
		terms: "Terms of Use",
		office: "Office",
		address:
			"Makedonijaturist AD\nul. Filip Vtori Makedonski 5\n1000 Skopje, Macedonia",
		companyName: "Makedonijaturist AD",
		allRights: "All rights reserved.",
	},
	aboutPage: {
		hero: {
			label: "Local heart. Urban comfort.",
			heading: "About Makedonijaturist AD",
			intro:
				"Makedonijaturist AD is the corporate brand representing the group as a whole. For partners and guests, that means stable standards, organised coordination and a warm approach in every interaction.",
			portfolioLabel: "Portfolio",
			portfolioValue: "hotels",
			locationLabel: "Location",
			locationValue: "Skopje",
			focusLabel: "Focus",
			focusValue: "B2B and urban stays",
		},
		story: {
			heading1: "Authentic hospitality,",
			heading2: "modern organisation.",
			p1: "Macedonia has always been a land of guests, homes that open and cities that welcome travellers with a smile. Makedonijaturist AD grew from those values.",
			p2: "We combine the reliable systems of modern hotel management with the warmth of a host. Our goal is simple: every stay should be easy, warm and professional, without unnecessary complications.",
			forWhoLabel: "Who we work for",
		},
		audiences: [
			"Travel agencies, tour operators and DMC partners",
			"Corporations, institutions and event organisers",
			"Investors, partners and media",
		],
		goals: [
			{
				title: "Goal",
				description:
					"To make Macedonia the natural choice for guests seeking genuine hospitality, comfort and a local experience in an urban setting, for business guests, tourists, groups and events.",
			},
			{
				title: "Vision",
				description:
					"To be recognised for consistent standards, a modern approach to management and a strong local character in every hotel.",
			},
			{
				title: "Mission",
				description:
					"We manage city hotels, restaurants and congress facilities. We deliver stable quality through SOPs, training and clear organisation.",
			},
		],
		portfolioSection: {
			label: "Portfolio",
			heading: "Hotels with character",
			intro:
				"Each hotel has its own style, target audience and regular guests. Makedonijaturist AD stands as a quiet guarantee of quality and stability.",
			viewPortfolio: "View portfolio",
			contact: "Contact",
			skopje: "Skopje",
			brandArchTitle: "Endorsed brand architecture",
			brandArchDesc:
				"Hotel brands have the freedom to be clear and recognisable, while the group provides an umbrella of credibility and standards.",
			brandArchNote: "Proud part of Makedonijaturist AD",
		},
		valuesSection: {
			label: "Values",
			heading: "Values felt in every stay",
			intro:
				"A serious tone, a warm welcome and precise attention to detail. In our work there is no theatre, only discipline and care.",
			contactNote:
				"For offers, partnerships and corporate coordination, our team is available.",
			contactCta: "Contact us",
		},
		brandValues: [
			{
				title: "Hospitality with heart",
				description:
					"The guest is not just a room number. We treat them as a guest in our own home.",
			},
			{
				title: "Consistent standards",
				description:
					"Regardless of the hotel or shift, the core experience should be stable and predictable.",
			},
			{
				title: "Local spirit",
				description:
					"In the food, atmosphere, recommendations and approach, there is always a well-tuned local note.",
			},
			{
				title: "Professionalism and discipline",
				description:
					"We follow SOPs, procedures and agreed standards, with clear organisation and accountability.",
			},
			{
				title: "Innovation and efficiency",
				description:
					"We use tools and technology to streamline work and improve the guest experience.",
			},
			{
				title: "Accountability and integrity",
				description:
					"We keep our promises, take responsibility when problems arise and build a fair relationship with partners and guests.",
			},
		],
	},
	careerPage: {
		hero: {
			label: "Join the team",
			heading1: "Career at",
			heading2: "Makedonijaturist",
			intro:
				"We are looking for people who believe in hospitality with heart. Work in an environment where standards, team spirit and local character come first.",
			openPositionsLabel: "Open positions",
			hotelsLabel: "Hotels and venues",
			locationLabel: "Location",
			positionsLabel: "positions",
		},
		positions: {
			heading: "Open positions",
			noPositions: "No positions in this category.",
			apply: "Apply",
			partTime: "Part-time",
			fullTime: "Full-time",
		},
		filters: {
			all: "All",
			reception: "Reception",
			kitchen: "Kitchen",
			restaurant: "Restaurant & Bar",
			housekeeping: "Housekeeping",
			management: "Management",
			maintenance: "Maintenance",
			events: "Events",
		},
		inquiry: {
			heading1: "General application",
			heading2: "for employment",
			intro:
				"Don't see a suitable position? Send a general application and we will contact you when a suitable opportunity opens up.",
			bullets: [
				"Stable work environment in an established group",
				"Career development across all hotels in the portfolio",
				"Training and advancement programmes",
				"Collaboration with international hotel brands",
			],
			formHeading: "Submit application",
			formDesc: "Fill in the fields and attach your CV.",
			namePlaceholder: "Full name",
			phonePlaceholder: "Phone",
			emailPlaceholder: "Email address",
			uploadCv: "Upload CV",
			uploadDesc: "PDF, up to 5MB",
			submit: "Submit application",
			privacy: "Your data is treated confidentially in accordance with GDPR.",
		},
		modal: {
			positionLabel: "Position",
			partTime: "Part-time",
			fullTime: "Full-time",
			tasksHeading: "Job responsibilities",
			qualificationsHeading: "Required qualifications",
			offersHeading: "What Makedonijaturist offers",
			applyLabel: "Apply",
			fill: "Fill in the fields and attach your resume.",
			namePlaceholder: "Full name",
			phonePlaceholder: "Phone",
			uploadResume: "Upload resume",
			uploadDesc: "PDF, up to 5MB",
			submit: "Send application",
			privacy: "Your data is treated confidentially in accordance with GDPR.",
		},
	},
	contactPage: {
		hero: {
			label: "Contact",
			heading: "Get in touch with us",
			intro:
				"For stays, groups, events or corporate partnerships, send us a message. We will respond clearly and promptly.",
		},
		form: {
			label: "Message",
			heading: "Send a message",
			nameLabel: "Full name",
			namePlaceholder: "Your name",
			emailLabel: "Email address",
			phoneLabel: "Phone (optional)",
			hotelLabel: "Select hotel (optional)",
			hotelDefault: "General inquiry",
			messageLabel: "Message",
			messagePlaceholder: "Your message...",
			submit: "Send message",
		},
		info: {
			label: "Information",
			heading: "Contact information",
			mainOfficeLabel: "Main office",
			hotelsLabel: "Hotels, direct contact",
		},
		map: {
			directions: "Get directions",
		},
	},
	upravenOdbor: {
		backLink: "About",
		orgLabel: "Organization",
		heading: "Board of Directors",
		intro:
			"The Board of Directors is the collective management body of Makedonijaturist AD Skopje, directing the business policy and operations of the Company. The Board consists of 3 members. One member is entrusted with the role of President of the Board. The President directly leads and represents the Company.",
		membersHeading: "Members of the Board of Directors",
		responsibilities: "Responsibilities of the Board of Directors",
		responsibilitiesText:
			"The responsibilities of the Board of Directors arise from the Statute of Makedonijaturist AD Skopje.",
		moreLink: "More",
		contactNote:
			"For more information regarding the work of the Board of Directors, contact us.",
		contactBtn: "Contact",
		presidentTitle: "President",
		memberTitle: "Member",
		presidentName: "President of the Board of Directors",
		memberName: "Member of the Board of Directors",
		presidentDesc:
			"Leads the work of the Board of Directors and coordinates the strategic decisions of the company.",
		memberDesc:
			"Participates in strategic decision-making and oversees the operations of the company.",
	},
	nadzorenOdbor: {
		backLink: "About",
		orgLabel: "Organization",
		heading: "Supervisory Board",
		intro:
			"The Supervisory Board is the collective oversight body for the management of Makedonijaturist AD Skopje. The Supervisory Board consists of at least 3 members, one of whom serves as President of the Supervisory Board.",
		membersHeading: "Members of the Supervisory Board",
		responsibilities: "Responsibilities of the Supervisory Board",
		responsibilitiesText:
			"The responsibilities of the Supervisory Board arise from the Statute of Makedonijaturist AD Skopje.",
		moreLink: "More",
		contactNote:
			"For more information regarding the work of the Supervisory Board, contact us.",
		contactBtn: "Contact",
		presidentTitle: "President",
		memberTitle: "Member",
		presidentName: "President of the Supervisory Board",
		memberName: "Member of the Supervisory Board",
		presidentDesc:
			"Leads the work of the Supervisory Board and coordinates oversight activities for the company's operations.",
		memberDesc:
			"Participates in oversight of the operations and financial affairs of the company.",
	},
	hotelskiMenadzment: {
		backLink: "About",
		orgLabel: "Organization",
		heading: "Hotel Management",
		intro:
			"The General Managers of Makedonijaturist AD Skopje's hotels lead day-to-day operations and represent their hotels to guests and partners.",
		managersHeading: "General Managers",
		position: "General Manager",
		managers: [
			{
				hotel: "Holiday Inn Skopje",
				description:
					"Leads the overall operations of Holiday Inn Skopje, ensuring alignment with IHG standards and delivering an exceptional experience for business guests and MICE clients.",
			},
			{
				hotel: "Hotel Karposh",
				description:
					"Manages the day-to-day operations of Hotel Karposh, focusing on quality stays for business guests and long-term visitors in the heart of Skopje.",
			},
			{
				hotel: "Hotel Turist",
				description:
					"Leads operations at Hotel Turist, providing practical and comfortable stays for guests seeking a central location in Skopje.",
			},
			{
				hotel: "Hotel Bellevue",
				description:
					"Manages Hotel Bellevue, creating a peaceful and natural atmosphere for families and groups seeking a retreat away from the city.",
			},
		],
	},
	organizaciskaStruktura: {
		backLink: "About",
		orgLabel: "Organization",
		heading: "Organizational Structure",
		underConstruction: "Under construction",
		comingSoon: "This page is under construction. It will be available soon.",
	},
	povazniAkti: {
		backLink: "About",
		transparencyLabel: "Transparency",
		heading: "Key Documents",
		intro:
			"The key documents and acts regulating the operations of Makedonijaturist AD, available to shareholders and the public.",
		documentsHeading: "Documents and Acts",
		documentsDesc:
			"All important legal, financial and operational documents of the company, available for review and download.",
		download: "Download",
		noteLabel: "Note",
		noteText:
			"Documents are updated in accordance with legal obligations. To request specific documents or additional information, contact us through the contact form or directly at our address.",
		notFoundNote: "Can't find the document you're looking for? Contact us.",
		contactBtn: "Contact",
		categories: [
			{
				label: "Statutory Documents",
				docs: [
					{
						name: "Statute of Makedonijaturist AD",
						description:
							"The foundational act of the company governing the rights and obligations of shareholders, management bodies and the company's operations.",
						type: "PDF",
					},
					{
						name: "Corporate Governance Code",
						description:
							"The principles and standards of corporate governance regulating the relationships between management bodies and shareholders.",
						type: "PDF",
					},
				],
			},
			{
				label: "Financial Reports",
				docs: [
					{
						name: "Audited Financial Statements 2024",
						description:
							"Audited financial statements of Makedonijaturist AD for the 2024 financial year.",
						type: "PDF",
						href: "/Revidirani finansiski izvestai 2024.pdf",
					},
					{
						name: "Audited Financial Statements 2023",
						description:
							"Audited financial statements of Makedonijaturist AD for the 2023 financial year.",
						type: "PDF",
						href: "/Revidirani finansiski izvestai 2023.pdf",
					},
				],
			},
		],
	},
	newsPage: {
		label: "News",
		heading: "From our group",
		intro:
			"Follow the latest news, events and updates from Makedonijaturist and our hotels.",
		readMore: "Read more",
		newsImage: "Article image",
	},
	articlePage: {
		backToNews: "Back to news",
		mainImage: "Article main image",
		body1:
			"Makedonijaturist continues its mission to provide exceptional service and experience for all our guests across the hotel portfolio. This initiative is part of our long-term strategy for continuous growth and development.",
		keyPointsHeading: "Key points",
		body2:
			"Over the years, our commitment to quality and authentic Macedonian hospitality remains unchanged. This new phase brings the following improvements:",
		bullets: [
			"Enhanced services for our business guests",
			"Modernised premises and equipment",
			"Increased focus on local products and partnerships",
			"Digitalisation of services for easier booking",
		],
		whatNextHeading: "What's next",
		body3:
			"In the coming months, we plan to continue implementing new standards across all our properties. Our team is working diligently to ensure that every guest feels the warmth and professionalism that define our values.",
		body4:
			"For more information and offers, we invite you to contact us or visit our hotels.",
		backToAllNews: "Back to all news",
	},
	investitoriPage: {
		label: "Investors",
		heading: "Sign in",
		intro: "Enter your credentials to access the investor portal.",
		emailLabel: "Email address",
		passwordLabel: "Password",
		submit: "Sign in",
		announcementsHeading: "Announcements",
		announcementsDesc:
			"Publicly available documents and announcements for shareholders.",
		publishedLabel: "Published",
		attachmentsLabel: "Attachments",
		open: "View",
		announcements: [
			{
				title:
					"Decision on Appointing an Investor Contact Person No. 02 - 3374 of 04.06.2026",
				date: "04.06.2026",
				attachments: [
					{
						name: "Decision on Appointing an Investor Contact Person No. 02 - 3374 of 04.06.2026",
						href: "/investitori/%D0%9E%D0%B4%D0%BB%D1%83%D0%BA%D0%B0%20%D0%B7%D0%B0%20%D0%BD%D0%B0%D0%B7%D0%BD%D0%B0%D1%87%D1%83%D0%B2%D0%B0%D1%9A%D0%B5%20%D0%BD%D0%B0%20%D0%BB%D0%B8%D1%86%D0%B5%20%D0%B7%D0%B0%20%D0%BA%D0%BE%D0%BD%D1%82%D0%B0%D0%BA%D1%82%20%D1%81%D0%BE%20%D0%B8%D0%BD%D0%B2%D0%B5%D1%81%D1%82%D0%B8%D1%82%D0%BE%D1%80%D0%B8%20%D0%B1%D1%80.%2002%20-%203374%20%D0%BE%D0%B4%2004.06.2026.pdf",
						type: "PDF",
					},
				],
			},
			{
				title: "Proposed decisions for the assembly 22.05.2026",
				date: "29.04.2026",
				attachments: [
					{
						name: "Proposed decisions for the assembly",
						href: "/investitori/Predlog%20odluki%20za%20sobranie.pdf",
						type: "PDF",
					},
				],
			},
			{
				title: "Annual General Meeting of Shareholders 22.05.2026",
				date: "21.04.2026",
				attachments: [
					{
						name: "Public Notice Makedonijaturist 22.05.2026",
						href: "/investitori/Javen%20povik%20Makedonijaturist%2022.05.2026.pdf",
						type: "PDF",
					},
					{
						name: "Materials for General Meeting of Shareholders 22.05.2026",
						href: "/investitori/Materijali%20za%20akcionersko%20sobranie%2022.05.2026.pdf",
						type: "PDF",
					},
					{
						name: "Audited Financial Reports Makedonijaturist 2025",
						href: "/investitori/Revidirani%20finansiski%20izvestai%20Makedonijaturist%202025.pdf",
						type: "PDF",
					},
					{
						name: "Corporate Governance Code for Joint Stock Companies Listed on MSE",
						href: "/investitori/Kodeks%20za%20korporativno%20upravuvanje%20na%20AD%20kotirani%20na%20MSE.pdf",
						type: "PDF",
					},
					{
						name: "Corporate Governance Code Questionnaires",
						href: "/investitori/Prasalnici%20za%20KKU.xlsx",
						type: "XLSX",
					},
				],
			},
		],
	},
	privacyPolicy: {
		heading: "Privacy Policy",
		lastUpdated: "Last updated: 16 August 2023",
		intro:
			"This Privacy Policy explains what information we collect about you and the processing of personal data we carry out when you visit our website and/or use any of our services. At Makedonijaturist AD Skopje we collect only those personal data that are necessary to carry out our business in accordance with the law, while providing you with the best experiences and services.",
		sections: [
			{
				heading:
					"Who is the controller of personal data collections and how can you contact us?",
				paragraphs: [
					"The controller of personal data is Makedonijaturist AD Skopje, with registered address at ul. Filip Vtori Makedonski br.5, 1000 Skopje, Republic of North Macedonia.",
					"Email: maktur@makedonijaturist.com.mk",
					"Website: www.makedonijaturist.com.mk",
					"Phone: +389 2 3292 731",
				],
			},
			{
				heading: "Personal data we collect",
				paragraphs: [
					"When you use the services of Makedonijaturist AD hotels, upon concluding hotel service agreements, we process personal data (first name, last name, date of birth, type and number of identity document, residential address, email and phone number) required for our obligations under the Law on Hospitality Activity.",
					"Upon your registration and stay at Makedonijaturist AD hotels that have a cooperation agreement with IHG (Holiday Inn) and/or Best Western (Hotel Belvi), your personal data are also processed by those companies in accordance with their privacy policies.",
					"https://www.ihg.com/content/us/en/customer-care/privacy-policy",
					"https://www.bestwestern.com/en_US/about/privacy-policy.html",
				],
			},
			{
				heading: "Cookies",
				paragraphs: [
					"Our website uses cookies for analytical purposes via Google Analytics. Your browser can block or delete cookies through the browser settings.",
				],
			},
			{
				heading: "Retention period",
				paragraphs: [
					"We retain your personal data only for as long as necessary to fulfil the purposes for which they were collected. After the retention period expires, personal data are securely deleted.",
				],
			},
			{
				heading: "Data security",
				paragraphs: [
					"We take all necessary technical and organisational measures to protect your personal data from unauthorised access, alteration, disclosure or destruction.",
				],
			},
			{
				heading: "Your rights",
				paragraphs: [
					"Under the Law on Personal Data Protection, you have the right to:",
				],
				items: [
					"Access your personal data",
					"Request correction of incomplete or inaccurate personal data",
					"Request deletion of your personal data",
					"Object to the processing of your personal data",
					"Request restriction of personal data processing",
				],
				postParagraphs: [
					"To exercise your rights, you may contact our Data Protection Officer at dpo@act.com.mk",
				],
			},
			{
				heading: "Amendments",
				paragraphs: [
					"Makedonijaturist AD reserves the right to periodically update this Privacy Policy. In the event of material changes, we will inform you through our website.",
				],
			},
		],
		documentsHeading: "Forms for exercising your rights",
		documents: [
			{
				label: "Personal Data Protection Notice",
				href: "/privacydocs/Известување-за-заштита-на-лични-податоци.pdf",
			},
			{
				label: "Request for access to personal data",
				href: "/privacydocs/Барање-за-пристап-до-информации-за-обработката-на-личните-податоци.pdf",
			},
			{
				label: "Request for correction of personal data",
				href: "/privacydocs/Барање-за-исправка-на-моите-лични-податоци.pdf",
			},
			{
				label: "Request for deletion of personal data",
				href: "/privacydocs/Барање-за-бришење-на-лични-податоци.pdf",
			},
			{
				label: "Request for restriction of processing",
				href: "/privacydocs/Барање-за-ограничување-на-обработка-на-моите-лични-податоци.pdf",
			},
		],
	},
	termsOfService: {
		heading: "Terms of Use",
		lastUpdated: "Last updated: January 2025",
		sections: [
			{
				heading: "Acceptance of Terms",
				paragraphs: [
					"By accessing and using this website, you confirm that you have read, understood and agree to these Terms of Use. If you do not agree with any part of these terms, please do not use the website.",
				],
			},
			{
				heading: "Use of the Website",
				paragraphs: [
					"This website is intended for informational purposes only. The following are prohibited: using the website for unlawful or unauthorised purposes, attempting unauthorised access to the Company's systems or networks, distributing harmful, false or offensive content, and any action that could cause harm to the Company or third parties.",
				],
			},
			{
				heading: "Intellectual Property",
				paragraphs: [
					"All content on this website, including texts, images, logos, graphics and design, is the intellectual property of Makedonijaturist AD or their respective rights holders and is protected by applicable copyright law.",
					"Copying, reproduction, distribution or public display of any content without prior written consent from Makedonijaturist AD is prohibited.",
				],
			},
			{
				heading: "Limitation of Liability",
				paragraphs: [
					"The information on this website is provided for general informational purposes. Makedonijaturist AD makes no warranty as to its accuracy, completeness or currency.",
					"The Company accepts no liability for any direct or indirect damage, loss or costs arising from the use of or inability to use the website, even if advised of the possibility of such damage.",
				],
			},
			{
				heading: "External Links",
				paragraphs: [
					"This website may contain links to third-party websites. Makedonijaturist AD does not control and is not responsible for the content, privacy policies or practices of those websites.",
				],
			},
			{
				heading: "Modifications to These Terms",
				paragraphs: [
					"Makedonijaturist AD reserves the right to modify or update these Terms of Use at any time without prior notice. Continued use of the website following the publication of changes constitutes acceptance of the revised terms.",
				],
			},
			{
				heading: "Governing Law and Jurisdiction",
				paragraphs: [
					"These Terms of Use are governed by and construed in accordance with the laws of the Republic of North Macedonia. All disputes arising from or related to these Terms shall be resolved before the competent courts in Skopje.",
				],
			},
		],
	},
};

export const translations: Record<"mk" | "en", Translations> = { mk, en };
